import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { useTableSortingColumn } from "@components/Table/TableSorting";
import TableSortIcon from "@components/Table/TableSortIcon";
import { useMemo } from "react";
import { TableColumn } from "@components/Table/TableColumns";

const TableCell: FCX<{
    isHead?: boolean;
    isSub?: boolean;
    hasSub?: boolean;
    sortingKey?: string;
    isLoading?: boolean;
    accentLevel?: TableColumn['accentLevel'];
    lockAccent?: TableColumn['lockAccent'];
    isSortHighlightHidden?: boolean;
}> = ({
    isHead,
    isSub,
    hasSub,
    isLoading,
    sortingKey,
    children,
    testId,
    accentLevel,
    lockAccent,
    isSortHighlightHidden,
    ...props
}) => {
    const { isSorted, direction, onSort } = useTableSortingColumn(sortingKey);

    const onCellClick = useMemo(() => {
        if (isHead && sortingKey) {
            return onSort;
        }
    }, [isHead, sortingKey, onSort]);

    return (
        <div
            className={cn(
                "TableCell",
                isHead && "is-head",
                hasSub && "is-super",
                isSub && "is-sub",
                isHead && sortingKey && "TableHeadCellSorting",
                isLoading && "is-loading",
                isSorted && !isSortHighlightHidden && 'is-accent-extended',
                `accent-${Math.min(
                    (accentLevel ?? 0) + (isHead && !lockAccent ? 1 : 0) + (isSorted && !isSortHighlightHidden ? 4 : 0),
                    4
                )}`,
                props.className,
            )}
            data-testid={testId}
            {...props}
            onClick={onCellClick}
            style={{
                ...props.style,
                userSelect: onCellClick ? "none" : undefined,
            }}
        >
            {isHead && sortingKey && (
                <TableSortIcon isActive={isHead && isSorted} direction={direction}/>
            )}
            {children}
        </div>
    );
};

export default TableCell;